// Build a replacement off-screen, then apply it once. Loaded but collapsed
// branches are retained and refreshed so expanding them does not reveal old counts.
export const refreshLoadedAssetGroupTree = async ({tree, loadedKeys, expandedKeys, fetchChildren, toNode}) => {
    const loaded = new Set([...loadedKeys, ...expandedKeys]);
    const visit = async (previous, parent) => {
        const rows = await fetchChildren(parent);
        const previousByKey = new Map(previous.map(node => [node.key, node]));
        const nodes = [];
        for (const row of rows) {
            const node = toNode(row);
            const old = previousByKey.get(node.key);
            if (old?.children || loaded.has(node.key)) {
                node.children = await visit(old?.children || [], node);
                node.loaded = true;
                node.isLeaf = node.children.length === 0 && !node.hasChildren;
            }
            nodes.push(node);
        }
        // Unsaved nodes belong to the current editing interaction.
        return [...previous.filter(node => !node.id), ...nodes];
    };
    return visit(tree, null);
};
